import * as pdfjsLib from 'pdfjs-dist';
import Papa from 'papaparse';
import workerSrc from 'pdfjs-dist/build/pdf.worker?worker&url';

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

export const extractTextFromPdf = async (file: File): Promise<string> => {
    const fileReader = new FileReader();

    return new Promise<string>((resolve, reject) => {
        fileReader.onload = async () => {
            try {
                const typedarray = new Uint8Array(fileReader.result as ArrayBuffer);
                const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;
                let text = '';

                for (let i = 0; i < pdf.numPages; i++) {
                    const page = await pdf.getPage(i + 1);
                    const content = await page.getTextContent();
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const pageText = content.items.map((item: any) => item.str).join(' ');
                    text += pageText + '\n';
                }

                resolve(text);
            } catch (error) {
                reject(error);
            }
        };
        fileReader.readAsArrayBuffer(file);
    });
};

export const parseCsvFile = async (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        Papa.parse(file, {
            header: true,
            complete: (results) => {
                const data = results.data as Record<string, string>[];
                const text = data.map((row: Record<string, string>) => Object.values(row).join(',')).join('\n');
                resolve(text);
            },
            error: (error) => {
                reject(error);
            },
        });
    });
};

export const processFile = async (file: File): Promise<{ type: string, content: Blob }> => {
    if (file.type === 'application/pdf') {
        const text = await extractTextFromPdf(file);
        const blob = new Blob([text], { type: 'text/plain' });
        return { type: 'text', content: blob };
    } else if (file.type === 'text/csv') {
        const text = await parseCsvFile(file);
        const blob = new Blob([text], { type: 'text/plain' });
        return { type: 'text', content: blob };
    } else if (file.type.startsWith('image/')) {
        return { type: 'image', content: file };
    } else {
        throw new Error('Unsupported file type');
    }
};
